import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet, Event } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { MenuPrivilegeService } from './_services/menuPrivilege.service';
import { PermissionService } from './_services/permission.service';
import { StorageService } from './_services/storage.service';
import { filter } from 'rxjs';
import { PrivilegeResponse } from './_models/menuModel';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private menuPrivilegeService: MenuPrivilegeService,
    private permissionService: PermissionService,
    private storageService: StorageService
  ) {}
  isPermissionLoaded = false;
  /** path ของ NavigationEnd ครั้งล่าสุด (ตัด ?query / #fragment) — ใช้ข้ามการยิงสิทธิ์ซ้ำ (#456) */
  private lastPath: string | null = null;

  ngOnInit(): void {
    this.router.events
      .pipe(
       
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        const currentUrl = event.urlAfterRedirects;

        // เปลี่ยนแค่ query/fragment (หน้ารายการเขียนตัวกรอง/หน้า/sort ลง URL) ⇒ ไม่ยิงสิทธิ์ซ้ำ (#456)
        // ครั้งที่ข้ามคือครั้งที่ match สิทธิ์ไม่ได้อยู่แล้ว — ข้างล่างเทียบ currentUrl เต็มรวม query
        const path = currentUrl.split(/[?#]/)[0];
        if (path === this.lastPath) return;
        this.lastPath = path;

        const user = this.storageService.getUser();
        const roleCode = user?.roleCode;

        if (roleCode) {
          this.menuPrivilegeService.getMenuPrivilegeByRoleCode(roleCode)
            .subscribe({ next: (res: PrivilegeResponse) => {
              const allPrivileges = res.menus.flatMap(menu => menu.privilegeDetails);
              this.isPermissionLoaded = true;
             
              
              const match = allPrivileges.find(p => {
                const normalizedUrl = '/' + p.menuUrl.replace(/^\/+/, '');
                return normalizedUrl === currentUrl;
              });
             
              if (match) {
             
                this.permissionService.setPermission(
                  currentUrl,
                  match.isRead,
                  match.isEdit,
                  match.isApprove,
                  match.isDownload
                );
              } 
              
            },
            // โหลดพัง ⇒ ลืม path ไว้ ให้นำทางครั้งถัดไปใน path เดิม (เช่นกดค้นหา) ยิงใหม่ได้ (#456)
            error: () => { this.lastPath = null; } });

            
        }
      });
  }
}
